module.exports = {
  title: `Web Devlog`,
  description: `Today I learned in web development`,
  author: `RossenaHuh`,
  introduction: `Fast learning Web Developer with interests in state-of-art technologies & a person who continuously seeks for diversity and better communications in life.`,
  siteUrl: `https://github.com/rossenahuh`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `rossenahuh`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
  },
  icon: `content/assets/favicon.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: 'RossenaHuh', // Your disqus-short-name. check disqus.com.
    utterances: 'rossenahuh/my-dev-blog.git', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 7, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'rossena',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-125671205-2', // Add your google analytics tranking ID
}
